import { render, staticRenderFns } from "./relationalChart.vue?vue&type=template&id=63f3e106&scoped=true"
import script from "./relationalChart.vue?vue&type=script&lang=js"
export * from "./relationalChart.vue?vue&type=script&lang=js"
import style0 from "./relationalChart.vue?vue&type=style&index=0&id=63f3e106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3e106",
  null
  
)

export default component.exports